import { render, staticRenderFns } from "./LabelRouter.vue?vue&type=template&id=26fd2a04&"
import script from "./LabelRouter.vue?vue&type=script&lang=js&"
export * from "./LabelRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports